import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderStarActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.61 9.09999C23.41 8.47999 22.88 8.01999 22.24 7.90999L16.34 6.89999L13.56 1.59999C12.97 0.36999 11.05 0.35999 10.46 1.59999L7.67997 6.89999L1.77997 7.90999C0.419974 8.09999 -0.170026 9.91999 0.819974 10.87L4.99997 15.16L4.13997 21.09C3.89997 22.44 5.44997 23.56 6.64997 22.92L12.02 20.27L17.39 22.92C18.6 23.57 20.15 22.44 19.9 21.09L19.04 15.16L23.22 10.87C23.68 10.4 23.84 9.71999 23.63 9.09999H23.61Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderStarActiveIcon.displayName = 'HeaderStarActiveIcon';
